export default (basePath, id) => (
  `${basePath}${basePath[basePath.length - 1] === '/' ? '' : '/'}${encodeURIComponent(id)}`
)



// WEBPACK FOOTER //
// ./src/util/linkToRecord.js